import ModelUtil from '@leverege/model-util';
import CSVExportFormatterModel from "./exportFormatter/CSVExportFormatterModel.js";
const TYPE = 'export.ExportModel';
function create(extend) {
  return {
    type: TYPE,
    formatter: CSVExportFormatterModel.create(extend?.formatter),
    // csv,tsv,json,etc
    fields: [],
    filename: 'export',
    ...extend
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllArray('fields', 'Field', 'Fields'),
  ...ModelUtil.createAllValue('formatter'),
  ...ModelUtil.createAllValue('filename')
};